import React, { useState } from 'react';
import { Search, X, Plus, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Rokhnave = () => {
  const navigate = useNavigate();
  const [date, setDate] = useState('01/04/2025');
  const [records, setRecords] = useState([]);
  
  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalDate, setModalDate] = useState(() => {
    const today = new Date();
    return `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  });
  const [voucherNo, setVoucherNo] = useState('');
  const [gateNo, setGateNo] = useState('');
  const [personName, setPersonName] = useState('');
  const [resolutionNo, setResolutionNo] = useState('');
  const [resolutionDate, setResolutionDate] = useState(() => {
    const today = new Date();
    return `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  });
  const [notes, setNotes] = useState('');
  const [accountRows, setAccountRows] = useState([
    { id: 1, account: '', debitAmount: '', distributionAmount: '', balance: '' }
  ]);

  const handleSearch = () => {
    console.log('Searching for date:', date);
  };

  const handleOpenModal = () => {
    setShowModal(true);
    // Reset form
    const today = new Date();
    setModalDate(`${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`);
    setResolutionDate(`${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`);
    setVoucherNo('');
    setGateNo('');
    setPersonName('');
    setResolutionNo('');
    setNotes('');
    setAccountRows([{ id: 1, account: '', debitAmount: '', distributionAmount: '', balance: '' }]);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleAddRow = () => {
    const newId = accountRows.length > 0 ? Math.max(...accountRows.map(r => r.id)) + 1 : 1;
    setAccountRows([...accountRows, { id: newId, account: '', debitAmount: '', distributionAmount: '', balance: '' }]);
  };

  const handleDeleteRow = (id) => {
    if (accountRows.length > 1) {
      setAccountRows(accountRows.filter(row => row.id !== id));
    }
  };

  const handleRowChange = (id, field, value) => {
    setAccountRows(accountRows.map(row => 
      row.id === id ? { ...row, [field]: value } : row
    ));
  };

  const handleSave = () => {
    // Validate form
    if (!personName.trim()) {
      alert('कृपया व्यक्तीचे नाव प्रविष्ट करा');
      return;
    }

    // Calculate total amounts
    const totalDebit = accountRows.reduce((sum, row) => sum + (parseFloat(row.debitAmount) || 0), 0);

    const newRecord = {
      date: modalDate,
      serialNo: voucherNo,
      name: personName,
      amount: totalDebit,
      cess: notes,
      proof: ''
    };

    setRecords([...records, newRecord]);
    console.log('Saved record:', newRecord);
    console.log('Account rows:', accountRows);
    handleCloseModal();
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white px-6 py-3 rounded-t-lg flex justify-between items-center">
        <h1 className="text-xl font-semibold">रोख नावे</h1>
        <div className="flex gap-3">
          <button
            onClick={() => navigate(-1)}
            className="bg-white/20 hover:bg-white/30 text-white px-4 py-1 rounded text-sm font-medium flex items-center gap-2 backdrop-blur-sm transition"
          >
            <ArrowLeft size={16} />
            मागे
          </button>
          <button
            onClick={handleOpenModal}
            className="bg-green-500 hover:bg-green-600 px-4 py-1 rounded text-sm font-medium"
          >
            नोंद+
          </button>
        </div>
      </div>

      {/* Search Section */}
      <div className="bg-white px-6 py-4 border-b border-gray-200">
        <div className="flex items-center gap-4">
          <label className="text-gray-700 font-medium">दिनांक</label>
          <input
            type="text"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="border border-gray-300 rounded px-3 py-1 w-32"
            placeholder="01/04/2025"
          />
          <button
            onClick={handleSearch}
            className="bg-primary hover:bg-primary-dark text-white px-6 py-1 rounded font-medium"
          >
            शोधा
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-b-lg overflow-hidden shadow">
        <table className="w-full">
          <thead>
            <tr className="bg-primary text-white">
              <th className="px-4 py-3 text-left border-r border-primary-dark">दिनांक</th>
              <th className="px-4 py-3 text-left border-r border-primary-dark">वाउचर क्रमांक</th>
              <th className="px-4 py-3 text-left border-r border-primary-dark">व्यक्तीचे नाव</th>
              <th className="px-4 py-3 text-left border-r border-primary-dark">रक्कम</th>
              <th className="px-4 py-3 text-left border-r border-primary-dark">शेरा</th>
              <th className="px-4 py-3 text-left">पर्याय</th>
            </tr>
          </thead>
          <tbody>
            {records.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-6 text-gray-500 text-left">
                  No records found
                </td>
              </tr>
            ) : (
              records.map((record, index) => (
                <tr key={index} className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-4 py-3">{record.date}</td>
                  <td className="px-4 py-3">{record.serialNo}</td>
                  <td className="px-4 py-3">{record.name}</td>
                  <td className="px-4 py-3">{record.amount}</td>
                  <td className="px-4 py-3">{record.cess}</td>
                  <td className="px-4 py-3">{record.proof}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="bg-blue-600 px-4 py-3 flex items-center justify-center gap-2">
          <button className="bg-blue-500 hover:bg-blue-400 text-white px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            «
          </button>
          <button className="bg-blue-500 hover:bg-blue-400 text-white px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            ‹
          </button>
          <span className="bg-white text-gray-700 px-3 py-1 rounded font-medium">1</span>
          <button className="bg-blue-500 hover:bg-blue-400 text-white px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            ›
          </button>
          <button className="bg-blue-500 hover:bg-blue-400 text-white px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            »
          </button>
          <select className="bg-white border border-gray-300 rounded px-2 py-1 ml-2">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-5xl max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-primary to-primary-dark text-white px-6 py-3 rounded-t-lg flex justify-between items-center sticky top-0">
              <h2 className="text-xl font-semibold">रोख नावे</h2>
              <button onClick={handleCloseModal} className="text-white hover:text-gray-200">
                <X size={24} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6">
              {/* Date and Voucher Button */}
              <div className="flex items-center gap-4 mb-4">
                <label className="text-gray-700 font-medium">दिनांक</label>
                <input
                  type="text"
                  value={modalDate}
                  onChange={(e) => setModalDate(e.target.value)}
                  className="border border-gray-300 rounded px-3 py-1 w-32"
                />
                <input
                  type="date"
                  onChange={(e) => {
                    const selectedDate = new Date(e.target.value);
                    const formattedDate = `${String(selectedDate.getDate()).padStart(2, '0')}/${String(selectedDate.getMonth() + 1).padStart(2, '0')}/${selectedDate.getFullYear()}`;
                    setModalDate(formattedDate);
                  }}
                  className="border border-gray-300 rounded px-2 py-1"
                />
                <button className="bg-green-500 hover:bg-green-600 text-white px-4 py-1 rounded font-medium ml-4">
                  नावे वॉउचर
                </button>
                <div className="ml-auto flex items-center gap-4">
                  <label className="text-gray-700 font-medium">गेट क्र.</label>
                  <input
                    type="text"
                    value={voucherNo}
                    onChange={(e) => setVoucherNo(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-1 w-24"
                  />
                  
                </div>
              </div>

              {/* Person Name */}
              <div className="flex items-center gap-4 mb-4">
                <label className="text-gray-700 font-medium">व्यक्तीचे नाव :</label>
                <div className="flex-1 flex items-center gap-2">
                  <input
                    type="text"
                    value={personName}
                    onChange={(e) => setPersonName(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-1 flex-1"
                    placeholder="
                    व्यक्तीचे नाव :"
                  />
                  <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded">
                    <Search size={20} />
                  </button>
                </div>
              </div>

              {/* Resolution Number and Date */}
              <div className="flex items-center gap-4 mb-6">
                <label className="text-gray-700 font-medium">resolutionNo :</label>
                <input
                  type="text"
                  value={resolutionNo}
                  onChange={(e) => setResolutionNo(e.target.value)}
                  className="border border-gray-300 rounded px-3 py-1 flex-1"
                  placeholder="resolution No भरा"
                />
                <label className="text-gray-700 font-medium ml-4">ठराव दिनांक:</label>
                <input
                  type="text"
                  value={resolutionDate}
                  onChange={(e) => setResolutionDate(e.target.value)}
                  className="border border-gray-300 rounded px-3 py-1 w-32"
                />
                <input
                  type="date"
                  onChange={(e) => {
                    const selectedDate = new Date(e.target.value);
                    const formattedDate = `${String(selectedDate.getDate()).padStart(2, '0')}/${String(selectedDate.getMonth() + 1).padStart(2, '0')}/${selectedDate.getFullYear()}`;
                    setResolutionDate(formattedDate);
                  }}
                  className="border border-gray-300 rounded px-2 py-1"
                />
              </div>

              {/* Account Selection Table */}
              <div className="overflow-x-auto mb-4">
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-blue-600 text-white">
                      <th className="px-2 py-2 text-left border-r border-blue-500 w-12">#</th>
                      <th className="px-4 py-2 text-left border-r border-blue-500">लेखाची निवड</th>
                      <th className="px-4 py-2 text-left border-r border-blue-500 w-32">नावे रक्कम</th>
                      <th className="px-4 py-2 text-left border-r border-blue-500 w-32">वाटपाची रक्कम</th>
                      <th className="px-4 py-2 text-left border-r border-blue-500">विस्तरण</th>
                      <th className="px-4 py-2 text-center w-20">
                        <button 
                          onClick={handleAddRow}
                          className="bg-blue-500 hover:bg-blue-400 text-white rounded p-1"
                        >
                          <Plus size={16} />
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {accountRows.map((row, index) => (
                      <tr key={row.id} className="border-b border-gray-200">
                        <td className="px-2 py-2 text-center border-r border-gray-200">{index + 1}</td>
                        <td className="px-2 py-2 border-r border-gray-200">
                          <input
                            type="text"
                            value={row.account}
                            onChange={(e) => handleRowChange(row.id, 'account', e.target.value)}
                            className="w-full border border-gray-300 rounded px-2 py-1"
                            placeholder="खाते निवडा"
                          />
                        </td>
                        <td className="px-2 py-2 border-r border-gray-200">
                          <input
                            type="number"
                            value={row.debitAmount}
                            onChange={(e) => handleRowChange(row.id, 'debitAmount', e.target.value)}
                            className="w-full border border-gray-300 rounded px-2 py-1 text-right"
                            placeholder="0"
                          />
                        </td>
                        <td className="px-2 py-2 border-r border-gray-200">
                          <input
                            type="number"
                            value={row.distributionAmount}
                            onChange={(e) => handleRowChange(row.id, 'distributionAmount', e.target.value)}
                            className="w-full border border-gray-300 rounded px-2 py-1 text-right"
                            placeholder="0"
                          />
                        </td>
                        <td className="px-2 py-2 border-r border-gray-200">
                          <input
                            type="text"
                            value={row.balance}
                            onChange={(e) => handleRowChange(row.id, 'balance', e.target.value)}
                            className="w-full border border-gray-300 rounded px-2 py-1"
                          />
                        </td>
                        <td className="px-2 py-2 text-center">
                          <button
                            onClick={() => handleDeleteRow(row.id)}
                            className="bg-red-500 hover:bg-red-600 text-white rounded p-1"
                            disabled={accountRows.length === 1}
                          >
                            <X size={16} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Notes */}
              <div className="mb-6">
                <label className="text-gray-700 font-medium block mb-2">शेरा</label>
                <textarea
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  rows="3"
                  placeholder="शेरा"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-center gap-4">
                <button
                  onClick={handleSave}
                  className="bg-green-500 hover:bg-green-600 text-white px-8 py-2 rounded font-medium"
                >
                  साठवणे
                </button>
                <button
                  onClick={handleCloseModal}
                  className="bg-red-500 hover:bg-red-600 text-white px-8 py-2 rounded font-medium"
                >
                  रद करणे
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rokhnave;
